import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { Icon } from "../Icon";
import { ValueContent } from "../ValueContent";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var Value = /*#__PURE__*/memo(function (_ref) {
  var _packageItem$value, _packageItem$value2;
  var packageItem = _ref.packageItem,
    isDark = _ref.isDark,
    cardType = _ref.cardType;
  if (packageItem !== null && packageItem !== void 0 && (_packageItem$value = packageItem.value) !== null && _packageItem$value !== void 0 && _packageItem$value.includes('infinitySymbol')) {
    return /*#__PURE__*/React.createElement(ValueContent, {
      cardType: cardType,
      packageItem: packageItem,
      "data-t-id": "components-Value"
    }, /*#__PURE__*/React.createElement(Icon, {
      className: cn('infinity'),
      name: isDark ? 'infinityWhite' : 'infinityConstructor',
      "data-t-id": "components-Value"
    }));
  }
  if (packageItem !== null && packageItem !== void 0 && (_packageItem$value2 = packageItem.value) !== null && _packageItem$value2 !== void 0 && _packageItem$value2.includes('constructor')) {
    return /*#__PURE__*/React.createElement(ValueContent, {
      cardType: cardType,
      packageItem: packageItem
    }, /*#__PURE__*/React.createElement(Icon, {
      className: cn('settings', {
        'settings--max': cardType === 'max'
      }),
      name: "settings",
      "data-t-id": "components-Value"
    }));
  }
  return /*#__PURE__*/React.createElement(ValueContent, {
    cardType: cardType,
    packageItem: packageItem
  }, /*#__PURE__*/React.createElement(Text, {
    color: isDark ? 'white' : 'grey95',
    size: cardType === 'cut' ? 'size2-m' : 'size1-m',
    tagType: "span",
    "data-t-id": "components-Value"
  }, packageItem.value));
});